import { getOrgGroups } from "../services/globalData"

export const findGroup = (group) =>{
     return getOrgGroups().find((grp)=>grp._id===group);
}